import { Space, Text } from '@procurify/ui'

import { CatalogItemDetailsSparkle } from './CatalogItemDetailsSparkle'
import { type ConversationDetailListBlock } from '../../value-objects/ConversationTurnItem'
import { ConversationDetailIcons } from '../../value-objects/enums'
import { ConversationMarkdown } from '../ConversationMarkdown'

export interface ICatalogItemDetailsListBlockProps {
  block: ConversationDetailListBlock
}

export const CatalogItemDetailsListBlock = ({
  block,
}: ICatalogItemDetailsListBlockProps) => (
  <Space direction='vertical' size='small'>
    {block.items.map((item) => (
      <Space
        key={`${item.title ?? ''}-${item.body ?? ''}`}
        direction='horizontal'
        size='xsmall'
      >
        {item.icon === ConversationDetailIcons.SPARKLE && (
          <CatalogItemDetailsSparkle />
        )}
        <Space direction='vertical' size='xsmall'>
          {item.title && (
            <Text bold className='fs-mask'>
              <ConversationMarkdown content={item.title} isInline />
            </Text>
          )}
          {item.body && (
            <Text className='fs-mask'>
              <ConversationMarkdown content={item.body} isInline />
            </Text>
          )}
        </Space>
      </Space>
    ))}
  </Space>
)
